import gql from 'graphql-tag'

export default gql`
  query cashflowDecisionableQuery($rid: Int!) {
    loan(rid: $rid) {
      cashflowDecisionable
      needsRedecision
    }
  }
`
